import React from "react";
import ListTable from "../../../Components/Table/ListTable";
import UserClubTableRow from "./UserClubTableRow";
import { useTranslation } from "../../../context/Internationalization";

const schema = (t) => [
  {
    id: 'name',
    label: t('team_name'),
    sortable: false,
    sx: { minWidth: 240 },
  },
  {
    id: 'isPremium',
    label: t('isPremium'),
    sortable: false,
    sx: { minWidth: 160 },
  }
]

const UserClubTable = ({ data = [], menuActions = [], lastElementRef, emptyMessage }) => {
  const { t } = useTranslation();
  const rowElement = (dato, index) => <UserClubTableRow
      key={dato._id}
      lastElementRef={lastElementRef}
      data={dato}
      index={index}
      menuActions={menuActions}
  />

  return (
    <ListTable
      rows={data}
      columns={schema(t)}
      rowElement={rowElement}
      tableAriaLabel={t('clubs')}
      minWidth={400}
      emptyMessage={emptyMessage}
    />
  );
};

export default UserClubTable;
